import { useEffect } from 'react';
import type { AntdMenuItem } from '@shared/types/menu';

interface UseMenuKeyboardOptions {
  items: AntdMenuItem[];
  isEnabled?: boolean;
  onSearchOpen?: () => void;
}

/**
 * Хук для keyboard navigation в меню
 */
export function useMenuKeyboard({ isEnabled = true, onSearchOpen }: UseMenuKeyboardOptions) {
  // Получить все пункты меню (плоский список) - может быть полезно в будущем
  // const getAllMenuItems = useCallback(
  //   (menuItems: AntdMenuItem[], flat: AntdMenuItem[] = []): AntdMenuItem[] => {
  //     menuItems.forEach((item) => {
  //       if (!item) return;
  //       flat.push(item);
  //       const children = getMenuChildren(item);
  //       if (children && children.length > 0) {
  //         getAllMenuItems(children, flat);
  //       }
  //     });
  //     return flat;
  //   },
  //   [],
  // );

  // Обработка горячих клавиш
  useEffect(() => {
    if (!isEnabled) return;

    const handleKeyDown = (e: KeyboardEvent) => {
      // Ctrl+K или Cmd+K - открыть поиск в меню
      if ((e.ctrlKey || e.metaKey) && e.key === 'k') {
        // Проверяем, что не в input/textarea
        const target = e.target as HTMLElement;
        if (target.tagName === 'INPUT' || target.tagName === 'TEXTAREA') {
          return;
        }

        e.preventDefault();
        onSearchOpen?.();
        return;
      }

      // Escape - закрыть мобильное меню (если открыто)
      if (e.key === 'Escape') {
        const drawer = document.querySelector('.ant-drawer-open');
        if (drawer) {
          // Закрываем drawer через событие
          const closeButton = drawer.querySelector('.ant-drawer-close');
          if (closeButton) {
            (closeButton as HTMLElement).click();
          }
        }
      }
    };

    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [isEnabled, onSearchOpen]);

  return {
    // Можно добавить дополнительные функции
  };
}

